module.exports = __webpack_public_path__ + "images/wwvoertuigen_small50bbc34f9c0e81adaf9b2b5d04c089a5.png";